/**
 * Types reducer.
 * @module reducers/types/types
 *
 * Customização: aplica `sortContentTypes` na lista devolvida por `@types`.
 *
 * A ordenação acontece aqui, e não em `Toolbar/Types.jsx`, por dois motivos:
 * `Types.jsx` se reconecta ao store por conta própria (ordenar no
 * `mapStateToProps` do `Toolbar` customizado não teria efeito), e ordenar no
 * reducer serve todos os consumidores de uma vez — o menu do Toolbar e o
 * dropdown "Adicionar" de `/contents`.
 */

import { GET_CONTENT, GET_TYPES } from '@plone/volto/constants/ActionTypes';
import { flattenToAppURL, getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { hasApiExpander } from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';
import { sortContentTypes } from 'volto-ministerio-publico-federal/helpers/ContentTypes/ContentTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  types: [],
};

const sorted = (types) =>
  sortContentTypes(types, config.settings?.addContentTypesOrder ?? []);

/**
 * Types reducer.
 * @function types
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function types(state = initialState, action = {}) {
  let hasExpander;
  switch (action.type) {
    case `${GET_TYPES}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_CONTENT}_SUCCESS`:
      hasExpander = hasApiExpander(
        'types',
        getBaseUrl(flattenToAppURL(action.result['@id'])),
      );
      if (hasExpander && !action.subrequest) {
        return {
          ...state,
          error: null,
          loading: false,
          loaded: true,
          types: sorted(action.result['@components'].types),
        };
      }
      return state;
    case `${GET_TYPES}_SUCCESS`:
      hasExpander = hasApiExpander(
        'types',
        getBaseUrl(flattenToAppURL(action.result['@id'])),
      );
      if (!hasExpander) {
        return {
          ...state,
          error: null,
          loading: false,
          loaded: true,
          types: sorted(action.result),
        };
      }
      return state;
    case `${GET_TYPES}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
        types: [],
      };
    default:
      return state;
  }
}
